import React, { useState, useRef, useEffect } from 'react';
import { FaChevronLeft, FaEllipsisV } from 'react-icons/fa';

const BasketHeader = ({ onBack, title, description, onEdit, onDelete }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const menuRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleEditClick = () => {
    setMenuOpen(false);
    onEdit();
  };

  const handleDeleteClick = () => {
    setMenuOpen(false);
    onDelete();
  };

  return (
    <div className="bg-cranberry-700 text-white py-3 sm:py-4 shadow-md mb-4 sm:mb-8 w-full">
      <div className="container mx-auto px-3 sm:px-4 flex items-center justify-between">
        <button
          onClick={onBack}
          className="text-white hover:text-butter-500 focus:outline-none transition-colors duration-300 p-1.5 sm:p-2"
          aria-label="Go back"
        >
          <FaChevronLeft size={20} className="sm:w-6 sm:h-6" />
        </button>
        <div 
          className="flex-grow mx-2 sm:mx-4"
          onMouseEnter={() => setShowDescription(true)}
          onMouseLeave={() => setShowDescription(false)}
          ref={titleRef}
        >
          <h2 className="text-xl sm:text-3xl font-bold text-center cursor-pointer truncate px-2">
            {title}
          </h2>
          {showDescription && description && (
            <div className="absolute left-1/2 transform -translate-x-1/2 mt-2 p-2 bg-white text-neutral-900 rounded-xl border-2 border-neutral-900 shadow-lg z-20 w-[calc(100%-2rem)] sm:w-64 mx-auto">
              <p className="text-sm">{description}</p>
            </div>
          )}
        </div>
        <div className="relative" ref={menuRef}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-white hover:text-butter-500 focus:outline-none transition-colors duration-300 p-2"
            aria-label="Basket options"
          >
            <FaEllipsisV size={24} />
          </button>
          {menuOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-xl border-2 border-neutral-900 shadow-lg z-10 overflow-hidden">
              <button 
                onClick={handleEditClick} 
                className="block w-full text-left px-4 py-2 text-neutral-900 hover:bg-neutral-50 transition-colors duration-300"
              >
                Edit Basket
              </button>
              <button 
                onClick={handleDeleteClick} 
                className="block w-full text-left px-4 py-2 text-cranberry-700 hover:bg-neutral-50 transition-colors duration-300"
              >
                Delete Basket
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BasketHeader;
